import styled, { css } from "styled-components";

export const Container = styled.div`
    font-size: 1.2rem;
    margin-bottom: 4.5rem;

    .arrowBack{
        margin-bottom: 1.5rem;
        background: #7A05A7;
        color: #FFF;
        max-width: max-content;
        padding: 0.4rem;
        font-size: 0.95rem;
        border-radius: 3px;

        display: flex;
        align-items: center;

        svg{
            font-size: 1.2rem;
            margin-right: 0.2rem;
            color: #FFF;
        }

        @media (min-width: 960px){
            cursor: pointer;
        }
    }

`

export const SelectAll = styled.div`
    display: flex;
    align-items: center;

    margin: 1rem 0;
`

export const ButtonFetchMore = styled.div`
    padding: 0.5rem;
    border-radius: 5px;
    background: #7A05A7;
    color: #FFF;
    margin: 3rem auto;
    max-width: 300px;
    cursor: pointer;
    opacity: ${props => props.isLoading ? 0.5 : 1};
    pointer-events: ${props => props.isLoading ? 'none' : 'all'};
    text-align: center;
`

export const ContainerButton = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: 0 20px 20px 20px;
    z-index: 99;

    background: #FFF;

    ${props => props.isDisabled && css`
        button{
            opacity: 0.5;
            pointer-events: none;
        }
    `}
`